import ThisRecipeFeatures, {
  ThisRecipeFeaturesProps,
} from "./ThisRecipeFeatures";

export { ThisRecipeFeatures, ThisRecipeFeaturesProps };

export default ThisRecipeFeatures;
